/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Actions_Done_FailedInputs */



/**
* | output |
* | --- |
* | "The completed action points did not load. Try again." |
*
* @param {Meeting_Prep_Actions_Done_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_actions_done_failed = /** @type {((inputs?: Meeting_Prep_Actions_Done_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Actions_Done_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De afgeronde actiepunten laden niet. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les points d'action terminés ne se chargent pas. Réessayez.")
	return /** @type {LocalizedString} */ ("The completed action points did not load. Try again.")
});